















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Monitoring24JamIcuSectionCard extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ default: "" }) sub!: string;
}
